import { Color, Colors } from "../shared/colors";
import { BaseOverlayConfig } from "../shared/config";
import { defineOverlay } from "../shared/functions";
export const MinProgressBar = defineOverlay({
    defaults: {
        backgroundColor: Color.DEFAULT_RED,
    },
    details: {
        category: "progress",
        description: "Utilize our dynamic Minimal progress bar overlay to enhance your Tiltify fundraising campaign. This overlay fits any layout and tracks your fundraising total.",
        features: [
            "Fundraising amount",
            "Fits most games",
            "Milestones",
            "Takes up less space",
        ],
        flags: {
            isFeatured: false,
            isNew: false,
            isUpdated: false,
            isVisible: true,
        },
        icon: "progress-bars/min.png",
        name: "Minimal Progress Bar",
        obsDimensions: {
            height: "95px",
            width: "300px",
        },
        path: "/overlays/min",
        shortDescription: "This progress bar fits any layout and tracks your fundraising total.",
        shortName: "Minimal",
        slug: "min",
    },
    schema: BaseOverlayConfig.extend({
        backgroundColor: Colors.default(() => MinProgressBar._config.defaults.backgroundColor).optional(),
    }),
});
//# sourceMappingURL=min.js.map